(function () {
  'use strict';

  var dialogs = document.querySelectorAll('#slideout-ajax-cart, #modal-ajax-cart');
  var pageContent = document.querySelector('.site-wrap');

  if (!dialogs.length || !pageContent) return;

  function getFocusableElements(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.closest('[inert]') &&
        !element.hasAttribute('hidden') &&
        element.getClientRects().length > 0 &&
        window.getComputedStyle(element).visibility !== 'hidden';
    });
  }

  dialogs.forEach(function (dialog) {
    var opener = null;
    var addedPageInert = false;

    function findOpener() {
      return document.querySelector('[popovertarget="' + dialog.id + '"]');
    }

    dialog.addEventListener('beforetoggle', function (event) {
      if (event.newState === 'open') {
        var activeElement = document.activeElement;
        opener = activeElement && activeElement !== document.body && !dialog.contains(activeElement)
          ? activeElement
          : findOpener();
      }
    });

    dialog.addEventListener('toggle', function (event) {
      var isOpen = event.newState
        ? event.newState === 'open'
        : dialog.matches(':popover-open');

      if (isOpen) {
        if (!opener) opener = findOpener();

        if (!pageContent.hasAttribute('inert')) {
          pageContent.setAttribute('inert', '');
          addedPageInert = true;
        }

        window.requestAnimationFrame(function () {
          var heading = dialog.querySelector('#mini-cart-heading');
          var firstFocusable = getFocusableElements(dialog)[0];
          var focusTarget = heading || firstFocusable;

          if (focusTarget) focusTarget.focus();
        });
        return;
      }

      if (addedPageInert) {
        pageContent.removeAttribute('inert');
        addedPageInert = false;
      }

      var activeElement = document.activeElement;
      if (opener && opener.isConnected &&
          (activeElement === document.body || dialog.contains(activeElement) || pageContent.contains(activeElement))) {
        window.requestAnimationFrame(function () {
          opener.focus();
          opener = null;
        });
      } else {
        opener = null;
      }
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;

      var focusableElements = getFocusableElements(dialog);
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      var heading = dialog.querySelector('#mini-cart-heading');

      if (!firstFocusable) {
        event.preventDefault();
        if (heading) heading.focus();
        return;
      }

      if (event.shiftKey &&
          (document.activeElement === firstFocusable || document.activeElement === heading || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey &&
          (document.activeElement === lastFocusable || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  });
})();
